import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import PostDetail from '../components/PostDetail';
import CommentSection from '../components/CommentSection';
import { getPost, categoryLabel } from '../api/community';
import { buildPostJsonLd, buildBreadcrumb } from '../utils/postJsonLd';

export default function CommunityPostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true); setError(null);
    getPost(id)
      .then(data => { if (active) setPost(data.post); })
      .catch(err => { if (active) setError(err); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id]);

  const postJsonLd = post ? buildPostJsonLd(post) : null;
  const breadcrumb = post ? buildBreadcrumb(post) : null;
  const ogImage = post && Array.isArray(post.imageUrls) && post.imageUrls.length > 0
    ? post.imageUrls[0] : null;

  return (
    <div className="container" style={{ paddingTop: 100, paddingBottom: 60, maxWidth: 800 }}>
      <title>{post?.title ? `${post.title} - 커뮤니티 | KOA DETAILING` : '글 보기 | KOA DETAILING'}</title>
      {post && (
        <meta
          name="description"
          content={(post.body || '').replace(/\s+/g, ' ').trim().slice(0, 160)}
        />
      )}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {post && <meta property="og:title" content={post.title} />}
      {post && <meta property="og:type" content="article" />}
      {postJsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(postJsonLd)}
        </script>
      )}
      {breadcrumb && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumb)}
        </script>
      )}

      <nav style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 16 }}>
        <Link to="/community" style={{ color: 'var(--text-muted)' }}>커뮤니티</Link>
        {post?.category && (
          <>
            <span style={{ margin: '0 6px' }}>›</span>
            <Link to={`/community/${post.category}`} style={{ color: 'var(--text-muted)' }}>
              {categoryLabel(post.category)}
            </Link>
          </>
        )}
      </nav>

      {loading && (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 40 }}>
          로딩 중...
        </p>
      )}

      {error && !loading && (
        <div style={{
          padding: 20, borderRadius: 'var(--radius)',
          background: 'rgba(255, 82, 82, 0.08)', border: '1px solid #ff5252',
        }}>
          <p style={{ color: '#ff5252', fontWeight: 700, marginBottom: 8 }}>
            ❌ {error.message || '글을 불러올 수 없습니다'}
          </p>
          <Link to="/community" className="btn btn-outline"
            style={{ fontSize: '0.85rem', padding: '6px 14px', display: 'inline-block', marginTop: 8 }}>
            커뮤니티로 돌아가기
          </Link>
        </div>
      )}

      {post && !loading && !error && (
        <>
          <PostDetail post={post} />
          <CommentSection postId={post.postId} />
        </>
      )}

      {post && !loading && !error && (
        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <Link to={`/community/${post.category}`}
            className="btn btn-outline"
            style={{ fontSize: '0.9rem', padding: '8px 20px' }}>
            ← {categoryLabel(post.category)} 목록으로
          </Link>
        </div>
      )}
    </div>
  );
}
